import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-relative-days',
  templateUrl: './relative-days.component.html',
  styleUrls: ['./relative-days.component.scss'],
  standalone: false,
})
export class RelativeDaysComponent {
  @Input() deliveryDateOptions;
  @Input() text;
  @Input() placeholder;
  @Input() options;
  @Input() dayTypeOptions;
  @Input() selectValue;
  @Input() displayDeleteInput;
  @Input() displayConjunctions;
  @Output() dataChanged = new EventEmitter();
  formatter = (x) =>
    x
      ?.toString()
      ?.replace('[[x]]', '<span style="color: var(--on-surface-light)">x</span>')
      ?.replace('[[productMetafieldKey]]', '');

  constractor() {}

  setOption(selectedValue: any) {
    this.selectValue = { ...this.selectValue, [selectedValue?.property]: selectedValue.value };
    if (!this.selectValue.before && this.selectValue?.data?.value?.includes('Before')) {
      this.selectValue.before = this.deliveryDateOptions[0];
    }
    if (
      this.dayTypeOptions &&
      !this.selectValue.dayType &&
      this.selectValue.data?.value &&
      !this.selectValue.data.value.includes('Month')
    ) {
      this.selectValue.dayType = this.dayTypeOptions[0];
    }
    this.dataChanged.emit(this.selectValue);
  }

  deleteInput() {
    this.selectValue = { ...this.selectValue, data: null, x: null, before: null, dayType: null };
    this.dataChanged.emit(this.selectValue);
  }
}
